import { render, staticRenderFns } from "./HistoryStats.vue?vue&type=template&id=ab63a8f2&"
import script from "./HistoryStats.vue?vue&type=script&lang=js&"
export * from "./HistoryStats.vue?vue&type=script&lang=js&"
import style0 from "./HistoryStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports